export const siteConfig = {
  name: "悦己新知",
  tagline: "科学认识身体，悦纳真实自我",
  description: "专注于女性性健康科普的知识平台，科学解析自慰与潮喷的生理原理，帮助女性正确认识自身身体反应，消除误解，提升性健康意识。",
  url: "https://blissstream.github.io",
  email: "hello@yuejixinzhi.com",
  foundingYear: "2024",
  authorCount: "15+",
  articleCount: "120+",
  readerCount: "500,000+",
};